'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAutosuggest = require('react-autosuggest');

var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBar = function (_Component) {
  _inherits(SearchBar, _Component);

  function SearchBar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
      event.preventDefault();
      _this.props.onSubmit(event);
      return false;
    }, _this.getSectionSuggestions = function (section) {
      return section.data;
    }, _this.getSuggestionValue = function (suggestion) {
      return suggestion[_this.props.labelKey];
    }, _this.shouldRenderSuggestions = function (value) {
      return value.trim().length > _this.props.minLength;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          buttonText = _props.buttonText,
          minLength = _props.minLength,
          onChange = _props.onChange,
          onClear = _props.onClear,
          onFetch = _props.onFetch,
          onSelect = _props.onSelect,
          paramKey = _props.paramKey,
          placeholder = _props.placeholder,
          query = _props.query,
          renderSectionTitle = _props.renderSectionTitle,
          renderSuggestion = _props.renderSuggestion,
          suggestions = _props.suggestions;


      var inputProps = {
        name: paramKey,
        onChange: onChange,
        placeholder: placeholder,
        value: query
      };

      var theme = {
        container: 'container',
        containerOpen: 'containerOpen',
        input: 'input',
        sectionContainer: 'sectionContainer',
        sectionTitle: 'sectionTitle',
        suggestion: 'suggestion',
        suggestionHighlighted: 'suggestionFocused',
        suggestionsContainer: 'suggestionsContainer',
        suggestionsList: 'suggestionsList'
      };

      return _react2.default.createElement(
        'form',
        { className: 'SearchBar', onSubmit: this.onSubmit, action: '/evenements', method: 'get' },
        _react2.default.createElement(
          'div',
          { className: 'icon-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'icon' },
            _react2.default.createElement(_Icon2.default, { name: 'search' })
          ),
          _react2.default.createElement(_reactAutosuggest2.default, {
            suggestions: suggestions,
            multiSection: true,
            onSuggestionSelected: onSelect,
            onSuggestionsFetchRequested: onFetch,
            onSuggestionsClearRequested: onClear,
            getSuggestionValue: this.getSuggestionValue,
            getSectionSuggestions: this.getSectionSuggestions,
            renderSuggestion: renderSuggestion,
            renderSectionTitle: renderSectionTitle,
            shouldRenderSuggestions: this.shouldRenderSuggestions,
            alwaysRenderSuggestions: minLength === 0,
            inputProps: inputProps,
            theme: theme
          })
        ),
        _react2.default.createElement(
          'button',
          { type: 'submit' },
          buttonText
        )
      );
    }
  }]);

  return SearchBar;
}(_react.Component);

SearchBar.propTypes = {
  /** Text to display on the submit button (adaptive behaviour, not actually displayed) */
  buttonText: _propTypes2.default.string,
  /** Object key to use to get the suggestion label */
  labelKey: _propTypes2.default.string,
  /** Minimal length before the search endpoint is queried */
  minLength: _propTypes2.default.number,
  /** Mandatory method to update the input value */
  onChange: _propTypes2.default.func.isRequired,
  /** Mandatory method called when the suggestions should be cleared */
  onClear: _propTypes2.default.func.isRequired,
  /** Mandatory method called when the suggestions should be fetched */
  onFetch: _propTypes2.default.func.isRequired,
  /** Mandatory method called when a suggestion is selected */
  onSelect: _propTypes2.default.func.isRequired,
  /** Mandatory method called when the form is submitted */
  onSubmit: _propTypes2.default.func.isRequired,
  /** Key to associate to the search input */
  paramKey: _propTypes2.default.string,
  /** Placeholder text to display in the search input */
  placeholder: _propTypes2.default.string,
  /** Current value of the search input */
  query: _propTypes2.default.string,
  /** Optional method that returns a string or HTML to display a
   * section title (for adaptive design, not displayed) */
  renderSectionTitle: _propTypes2.default.func,
  /** Optional method that returns a string or HTML representing
   * a single suggestion item */
  renderSuggestion: _propTypes2.default.func.isRequired,
  /** The array of suggestions */
  suggestions: _propTypes2.default.array.isRequired
};
SearchBar.defaultProps = {
  buttonText: 'Rechercher',
  labelKey: 'label',
  minLength: 2,
  paramKey: 'q',
  placeholder: 'Événement, thème, lieu…',
  query: '',
  renderSectionTitle: function renderSectionTitle(section) {
    return section.meta.type;
  }
};
exports.default = SearchBar;
SearchBar.__docgenInfo = {
  'description': '',
  'methods': [{
    'name': 'onSubmit',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'event',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'getSectionSuggestions',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'section',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'getSuggestionValue',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'suggestion',
      'type': null
    }],
    'returns': null
  }, {
    'name': 'shouldRenderSuggestions',
    'docblock': null,
    'modifiers': [],
    'params': [{
      'name': 'value',
      'type': null
    }],
    'returns': null
  }],
  'displayName': 'SearchBar',
  'props': {
    'buttonText': {
      'defaultValue': {
        'value': '\'Rechercher\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Text to display on the submit button (adaptive behaviour, not actually displayed)'
    },
    'labelKey': {
      'defaultValue': {
        'value': '\'label\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Object key to use to get the suggestion label'
    },
    'minLength': {
      'defaultValue': {
        'value': '2',
        'computed': false
      },
      'type': {
        'name': 'number'
      },
      'required': false,
      'description': 'Minimal length before the search endpoint is queried'
    },
    'paramKey': {
      'defaultValue': {
        'value': '\'q\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Key to associate to the search input'
    },
    'placeholder': {
      'defaultValue': {
        'value': '\'\xC9v\xE9nement, th\xE8me, lieu\u2026\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Placeholder text to display in the search input'
    },
    'query': {
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'Current value of the search input'
    },
    'renderSectionTitle': {
      'defaultValue': {
        'value': '(section) => {\n  return section.meta.type;\n}',
        'computed': false
      },
      'type': {
        'name': 'func'
      },
      'required': false,
      'description': 'Optional method that returns a string or HTML to display a\nsection title (for adaptive design, not displayed)'
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'Mandatory method to update the input value'
    },
    'onClear': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'Mandatory method called when the suggestions should be cleared'
    },
    'onFetch': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'Mandatory method called when the suggestions should be fetched'
    },
    'onSelect': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'Mandatory method called when a suggestion is selected'
    },
    'onSubmit': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'Mandatory method called when the form is submitted'
    },
    'renderSuggestion': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'Optional method that returns a string or HTML representing\na single suggestion item'
    },
    'suggestions': {
      'type': {
        'name': 'array'
      },
      'required': true,
      'description': 'The array of suggestions'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/SearchBar.js
// module id = 590
// module chunks = 0